export const toRentalPayload = (data: any) => ({
	...data,
	price: {
		amount: data.price?.amount,
		currency: data.currency?.value
	},
	original_price: {
		amount: data.original_price?.amount,
		currency: data.currency?.value
	},
	booth_type: data.booth_type?.value
})
